import { ButtonHTMLAttributes, FC } from 'react';
import classNames from 'classnames';
import ButtonLoader from '@components/ButtonLoader/ui/ButtonLoader';
import styles from './Button.module.scss';
import { ButtonVariant } from '../model/types/ButtonVariant';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  url?: string;
  isLoading?: boolean;
}

/**
 * General and reusable component. It's clickable
 * @param children - The content to be displayed inside the button.
 * @param className - string
 * @param variant - "active" | "danger" | "underline" | "text" | "menu" | "inverted".
 * @param url - string
 * @param isLoading - boolean flag to show loader.
 * @param restProps - rest props
 * @returns A button element representing the button.
 */

const Button: FC<ButtonProps> = ({
  children,
  className,
  variant = 'default',
  url,
  isLoading = false,
  ...restProps
}) => {
  if (url) {
    return (
      <a
        onClick={(e) => e.stopPropagation()}
        download={url}
        href={url}
        className={classNames(styles.button, styles[variant], className)}
      >
        {children}
      </a>
    );
  }
  return (
    <button
      className={classNames(styles.button, styles[variant], className, {
        [styles.loading]: isLoading,
      })}
      {...restProps}
    >
      {isLoading ? <ButtonLoader size={20} /> : <>{children}</>}
    </button>
  );
};

export default Button;
